module.exports = __webpack_public_path__ + "static/img/fa-regular-400.88f0c5b.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fontawesome-5.10.2/webfonts/fa-regular-400.svg
// module id = 340
// module chunks = 1